<template>
  <svg :width="size" :height="Number(size) + 2" viewBox="0 0 6 8" :fill="color" xmlns="http://www.w3.org/2000/svg" class="play">
    <path
      d="M5.103 3.99886L0.75 1.47361V6.52411L5.103 3.99886ZM5.697 3.47686C5.78895 3.52951 5.86536 3.60551 5.91851 3.69717C5.97165 3.78883 5.99964 3.89291 5.99964 3.99886C5.99964 4.10482 5.97165 4.20889 5.91851 4.30056C5.86536 4.39222 5.78895 4.46822 5.697 4.52086L0.92475 7.28986C0.53475 7.51636 0 7.25761 0 6.76786V1.22986C0 0.740113 0.53475 0.481363 0.92475 0.707863L5.697 3.47686Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: String,
      default: 6,
    },

    hoverColor: {
      type: String,
      default: '#8869fd',
    },
  },
};
</script>

<style scoped>
.play:hover path {
    fill: v-bind(hoverColor);
}
</style>
